import templateUrl from "webforms/formio/form-submissions.htm";
import controller from "webforms/formio/form-submissions.controller";

export default {
  bindings: {
    ngModel: "=?",
    hideHeader: "@",
    layout: "@",
    disableQueryString: "<",
    mode: "@",
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
